import useFilteredTables from "@/hooks/useFilteredTables";
import useAppStore from "@/store/useAppStore";
import SectionGrid from "@/components/grid/SectionGrid";
import DottedDivider from "@/components/grid/DottedDivider";
import AddExtraTableButton from "@/components/controls/AddExtraTableButton";

const SECTION_IDS = [0, 1, 2, 3, 4];

export default function TableGrid() {
  const breakfastStarted = useAppStore((s) => s.appState?.breakfast_started);
  const selectedMode = useAppStore((s) => s.selectedMode);
  const { mode, sections, dynamic, flat } = useFilteredTables();

  // Phase H Δ-13a — `Waiting` mode: flat responsive grid (no sections,
  // no dividers, no NR header, no AddExtra). Vertical scroll only.
  // Combines regular + dynamic tables, sorted by waiting_start_time ASC.
  // Doc 06 §5.1 + CR-0014a Stage 3 Q6.
  if (mode === "Waiting") {
    if (flat.length === 0) {
      return (
        <div
          data-testid="empty-waiting"
          className="px-3 py-12 text-center text-sm"
          style={{ color: "#6B7280" }}
        >
          No tables waiting.
        </div>
      );
    }
    return (
      <div data-testid="table-grid-waiting" className="px-3 py-4">
        <SectionGrid tables={flat} />
      </div>
    );
  }

  const nonEmptySections = SECTION_IDS.filter(
    (id) => sections[id] && sections[id].length > 0
  );

  // Phase H Δ-13 — AddExtra visibility: breakfast started AND
  // no status mode tab active. U-02 resolved. Doc 06 §6.
  const showAddExtra = !!breakfastStarted && selectedMode === null;
  const showNRLabel = selectedMode === null;

  const emptyEverywhere =
    nonEmptySections.length === 0 && dynamic.length === 0;

  return (
    <div data-testid="table-grid" className="px-3 py-4">
      {emptyEverywhere && (
        <div
          data-testid="empty-results"
          className="px-3 py-12 text-center text-sm"
          style={{ color: "#6B7280" }}
        >
          No tables match the current filters.
        </div>
      )}

      {nonEmptySections.map((sectionId, index) => (
        <div key={sectionId}>
          {index > 0 && <DottedDivider />}
          <SectionGrid tables={sections[sectionId]} />
        </div>
      ))}

      {dynamic.length > 0 && (
        <>
          <DottedDivider />
          <div data-testid="nr-section">
            {showNRLabel && (
              <div
                data-testid="nr-label"
                className="px-3 pt-0.5 pb-1 text-sm font-semibold"
                style={{ color: "#424242" }}
              >
                NR
              </div>
            )}
            <SectionGrid tables={dynamic} />
          </div>
        </>
      )}

      {showAddExtra && (
        <>
          <DottedDivider />
          <AddExtraTableButton visible={showAddExtra} />
        </>
      )}
    </div>
  );
}
